/**
 * /library/wiki/$articleId — redirect to the article reader.
 *
 * #223 — the documented IA uses `/library/wiki/$id`, but the
 * real article reader lives at `/library/article/$articleId`.
 * Deep links to the documented path now redirect cleanly to the
 * canonical reader.
 */
import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/library/wiki/$articleId')({
  component: WikiArticleRedirect,
});

function WikiArticleRedirect() {
  const { articleId } = Route.useParams();
  return (
    <Navigate
      to="/library/article/$articleId"
      params={{ articleId }}
      replace
    />
  );
}
